<!-- Read-only display of a submitted blood pressure answer (systolic/diastolic mmHg). -->

<script lang="ts" setup>
import type { BloodPressureInputValue } from '@sigma/common/forms/BloodPressureInput.js';

interface Props {
  /** The blood pressure answer value to display. */
  value: BloodPressureInputValue;
}

defineProps<Props>();
</script>

<template>{{ value.systolic }}/{{ value.diastolic }} mmHg</template>
